import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TechnologyPage.css';
import { 
  Monitor, 
  Sun, 
  Settings, 
  Zap, 
  Radio, 
  Network
} from 'lucide-react';

const TechnologyPage = () => {
  const navigate = useNavigate();
  
  const technologies = [
    {
      id: 1,
      title: 'العرض التوضيحي المباشر',
      subtitle: 'عرض توضيحي مباشر لمرسل COBALT FM',
      description: 'جرب واجهة COBALT التفاعلية واستكشف جميع الميزات المتقدمة المتاحة في مرسلاتنا عبر الإنترنت.',
      icon: <Monitor size={64} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/technology/online-demo'
    },
    {
      id: 2,
      title: 'نظام Solaris',
      subtitle: 'نظام راديو FM هجين بالطاقة',
      description: 'حل متطور يجمع بين الطاقة التقليدية والمتجددة لضمان بث مستمر وموثوق.',
      icon: <Sun size={64} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/technology/solaris'
    },
    {
      id: 3,
      title: 'التصميم والتطوير المخصص',
      subtitle: 'خدمات التصميم والتطوير المخصصة',
      description: 'نقدم حلول مخصصة مصممة خصيصاً لتلبية احتياجاتك الفريدة في مجال البث الإذاعي.',
      icon: <Settings size={64} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/technology/custom-design-and-development'
    },
    {
      id: 4,
      title: 'حلول الطاقة',
      subtitle: 'حلولنا لاستبدال طاقة GE',
      description: 'بديل موثوق وفعال لأنظمة الطاقة التقليدية مع تحسينات في الكفاءة والأداء.',
      icon: <Zap size={64} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/technology/power-solutions'
    },
    {
      id: 5,
      title: 'تقنية MicroMPX',
      subtitle: 'ترميز منخفض البت لإشارة FM MPX مركبة كاملة',
      description: 'تقنية ترميز متطورة تحافظ على جودة الصوت مع تقليل متطلبات النطاق الترددي.',
      icon: <Radio size={64} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/technology/micrompx'
    },
    {
      id: 6,
      title: 'شبكة MicroMPX SFN',
      subtitle: 'إضافة SFN لشبكة MicroMPX على مرسلات Cobalt',
      description: 'تقنية الشبكة أحادية التردد لتوسيع نطاق التغطية وتحسين جودة الإشارة.',
      icon: <Network size={64} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/technology/micrompx-sfn'
    }
  ];

  const handleTechnologyClick = (link) => {
    window.open(link, '_blank');
  };

  return (
    <div className="technology-page">
      <div className="container">
        {/* Page Header */}
        <div className="page-header">
          <h1 className="page-title">التكنولوجيا</h1>
          <p className="page-subtitle">
            اكتشف التقنيات المتطورة والابتكارات التي تجعل منتجات Aqua Broadcast في المقدمة
          </p>
        </div>

        {/* All Technologies Grid */}
        <section className="all-technologies">
          <h2 className="section-title">جميع التقنيات</h2>
          <div className="technologies-grid">
            {technologies.map((technology) => (
              <div 
                key={technology.id} 
                className="technology-card"
                onClick={() => handleTechnologyClick(technology.link)}
              >
                <div className="tech-icon">
                  {technology.icon}
                </div>
                <h3 className="tech-title">{technology.title}</h3>
                <h4 className="tech-subtitle">{technology.subtitle}</h4>
                <p className="tech-description">{technology.description}</p>
                <div className="tech-arrow">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Call to Action */}
        <section className="tech-cta-section">
          <div className="tech-cta-content">
            <h2 className="tech-cta-title">مهتم بتقنياتنا المتطورة؟</h2>
            <p className="tech-cta-description">
              اكتشف كيف يمكن لتقنياتنا المبتكرة أن تحسن من أداء محطتك الإذاعية
            </p>
            <div className="tech-cta-buttons">
              <button 
                className="tech-cta-button primary"
                onClick={() => window.open('https://aquabroadcast.co.uk/technology/online-demo', '_blank')}
              >
                جرب العرض التوضيحي
              </button>
              <button 
                className="tech-cta-button secondary"
                onClick={() => navigate('/contact')}
              >
                تواصل مع خبرائنا
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TechnologyPage;
